export default {
    init() {
        this.fileUpload();
        this.dragAndDropUpload();
        this.uploadSteps();
    },
    fileUpload() {
        const self = this;
        let fileTypes = ['csv', 'xls', 'xlsx'];
        let wrongFile = $('.wrong-file-type');
        let templateNotMatching = $('.template-not-matching');
        let uploadArea = $('.import-body--upload-row--upload-box');
        let filesList = $('.import-body--upload-row--list');
        let importFileInput = $('.import-file');

        importFileInput.on('change', function () {
             //DROP LIMITUOTA VIENAM FAILUI
            filesList.empty();
            
            if ($(this)[0].files.length > 0) {
                uploadArea.removeClass('invalid');

                let theseFiles = $(this)[0].files;
                let isSuccess = true;
                for (let i = 0; i < theseFiles.length; i++ ) {
                    let extension = theseFiles[i].name.split('.').pop().toLowerCase();
                    if ( !(fileTypes.indexOf(extension) > -1) ) {
                        isSuccess = false;
                    }
                }

                if (isSuccess) {
                    for (let i = 0; i < theseFiles.length; i++ ) {
                        filesList.append(`
                            <div class="item">${theseFiles[i].name}<span data-name="${theseFiles[i].name}"></span></div>
                        `);
                    }
                    self.deleteFileFromList();
                    templateNotMatching.hide(300);
                    wrongFile.slideUp(300);
                    uploadArea.removeClass('invalid');
                } else {
                    wrongFile.slideDown(300);
                    uploadArea.addClass('invalid');
                }
            } else {
                uploadArea.addClass('invalid');
                filesList.empty();
            }
        });
    },
    deleteFileFromList() {
        $('.import-body--upload-row--list .item span').on('click', function () {
            $(this).parent().remove();
            $('.import-file').val('');
            $('.import-body--upload-row--upload-box').addClass('invalid');
        });
    },
    dragAndDropUpload() {
        const self = this;
        let fileTypes = ['csv', 'xls', 'xlsx'];
        let wrongFile = $('.wrong-file-type');
        let templateNotMatching = $('.template-not-matching');
        let uploadArea = $('.import-body--upload-row--upload-box');
        let filesList = $('.import-body--upload-row--list');
        let explorerCheck = false;
        let safariCheck = false;

        if (navigator.userAgent.indexOf('Trident/') !== -1) {
            explorerCheck = true;
        } else {
            explorerCheck = false;
        }

        if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
            safariCheck = true;
        } else {
            safariCheck = false;
        }

        if (!safariCheck && !explorerCheck) {
            // Drag and drop
            window.addEventListener('dragenter', preventDefaults, false);
            window.addEventListener('dragleave', preventDefaults, false);
            window.addEventListener('dragover', preventDefaults, false);
            window.addEventListener('drop', preventDefaults, false);
            window.addEventListener('dragover', highlight, false);
            window.addEventListener('drop', dropFiles, false);
        } else {
            $('.import-body--upload-row--upload-box .text').html('Select your files');
        }

        function preventDefaults(e) {
            e.preventDefault();
            e.stopPropagation();
        }

        function highlight() {
            if ($('.import-next').hasClass('upload-step')) {
                $('.drag-and-drop-toggle').show();
            }
        }

        function dropFiles(e) {
            if ($('.import-next').hasClass('upload-step')) {
                $('.drag-and-drop-toggle').hide();
                filesList.empty();

                let filesAllowed = [];
                let files = e.dataTransfer.files;

                for (let i = 0; i < files.length; i++) {
                    let extension = files[i].name.split('.').pop().toLowerCase();
                    let isSuccess = fileTypes.indexOf(extension) > -1;
                    if (isSuccess) {
                        filesAllowed.push(files[i]);
                        templateNotMatching.hide(300);
                        wrongFile.slideUp(300);
                        uploadArea.removeClass('invalid');
                    } else {
                        wrongFile.slideDown(300);
                        uploadArea.addClass('invalid');
                        filesList.empty();
                        $('.import-file').val('');
                    }
                    //DROP LIMITUOTA VIENAM FAILUI
                    break;
                }

                generateFileList(filesAllowed);
                document.querySelector('.import-file').files = new FileListItem(filesAllowed);
            }
        }

        function generateFileList(files) {
            for (let file of files) {
                filesList.append(`<div class="item">"${file.name}" <span data-name="${file.name}"></span></div>`);
            }

            self.deleteFileFromList();
        }

        function FileListItem(a) {
            a = [].slice.call(Array.isArray(a) ? a : arguments)
            for (var c, b = c = a.length, d = !0; b-- && d;) d = a[b] instanceof File
            if (!d) throw new TypeError("expected argument to FileList is File or array of File objects")
            for (b = (new ClipboardEvent("")).clipboardData || new DataTransfer; c--;) b.items.add(a[c])
           
            return b.files
        }
    },
    uploadSteps() {
        const self = this;

        $('.import-next').on('click', function () {
            let thisBtn = $(this);

            if (thisBtn.hasClass('first-step')) {
                if ($('.import-select').val() !== '') {
                    $('.import-body--select-row').hide();
                    $('.import-subtitle').not('.changing').hide();
                    $('.import-body--upload-row').fadeIn(300);
                    $('.template-button').fadeIn(300);
                    $('.template-button a').attr('href', '/manage/import/import-template/'+$('.import-select').val());
                    $('.import-subtitle.changing').html('Upload .xls, .xlsx or .csv files');
                    thisBtn.removeClass('first-step');
                    setTimeout(function () {
                        thisBtn.addClass('upload-step');
                    }, 300);
                }
            }

            if (thisBtn.hasClass('upload-step')) {
                let uploadInput = $('.import-body--upload-row--upload-box .import-file');
                let importSelect = $('.import-select');
                let importSelectStorage = $('.import-select-storage');
                let uploadArea = $('.import-body--upload-row--upload-box');
                var actualFiles = uploadInput.prop('files');
                var data = new FormData();
                var files = actualFiles;
                var counter = 1;
                data.append('category', importSelect.val());
                data.append('storage', importSelectStorage.val());
                for (const file of files) {
                    data.append('doc'+counter, file, file.name);
                    counter++;
                }
                self.saveFiles(data);
                
                if (uploadInput.val() !== '' && !uploadArea.hasClass('invalid')) {
                    self.uploadProgressStep();
                } else {
                    uploadArea.addClass('invalid');
                }
            }
        });
    },
    uploadProgressStep() {
        $('.status-step-hide').hide();
        $('.import-body--progress-row').fadeIn(300);
        $('.import-body--progress-row .progress-bar span').css('transition', 'none');
        // TODO change to ajax upload, status
        

        let i = 0;
        if (i === 0) {
            i = 1;
            let elem = $('.import-body--progress-row .progress-bar span');
            let width = 1;
            let id = setInterval(frame, 10);
            function frame() {
                if (width >= 100) {
                    clearInterval(id);
                    i = 0;
                    $('.import-body--progress-row .progress-title').html('Completed');
                } else {
                    width++;
                    elem.css('width', width + '%');
                    $('.import-body--progress-row .progress-status').html(width + '%');
                    if(width > 2){
                        $('.import-body--progress-row .progress-bar span').css('transition', 'all .3s');
                    }
                }
            }
        }
    },
    saveFiles(data, category){
        function sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
          }
        $.ajax({
            url:'/manage/import/import-ajax',
            type: "POST",
            dataType: "json",
            data: data,
            contentType: false,
            processData: false,
            async: true,
            success: function (data)
            {
                if(!jQuery.isEmptyObject(data)){
                    sleep(2000).then(() => window.location.replace("/manage/import/imported-file/"+data));
                } else {
                    $('.import-body--progress-row').hide();
                    $('.status-step-hide').show();
                    $('.import-body--upload-row--upload-box').addClass('invalid');
                    $('.template-button').show();
                    $('.template-not-matching').slideDown(300);
                }
               
            }
        });
        
    }
}